const setHeader = (
  header: string,
  value: string | null | undefined,
  transform = (headerValue: string) => headerValue,
) => (value ? { [header]: transform(value) } : {});

export default setHeader;
